import AppExploreMore from "@components/Modules/AppExploreMore/AppExploreMore";
import { configCategory, configExploreMore } from "@pub/config";
import {
  Ads,
  CustomClassContext,
  Divider,
  SectionContext,
} from "@sphtech/dmg-design-system";
import { NoSSR } from "@sphtech/web2-core/components";
import cx from "classnames";
import { ReactNode, useContext } from "react";

import styles from "../category.module.css";
import { CategoryLayoutElementProps } from "../types/types";

export default function CategorySidebar({
  data,
}: CategoryLayoutElementProps): ReactNode {
  const customClass = useContext(CustomClassContext);
  const mobileAdBeforeVideoGallery =
    !!data.uniqSectionName && configCategory.videoGalleryLandscape?.display;
  const uniqueSectionNameOrTag = data.uniqSectionName ?? data.tagSlug;

  return (
    <div className={styles.sidebar}>
      {mobileAdBeforeVideoGallery ? (
        <Ads.AdsSideBarDesktop />
      ) : (
        <Ads.AdsSideBar />
      )}

      {configCategory.exploreMoreInPinned && uniqueSectionNameOrTag && (
        <div className={styles.pinnedExploreMore}>
          <NoSSR>
            <SectionContext.Provider value={{}}>
              <AppExploreMore
                uniqSectionName={data.uniqSectionName}
                tagName={data.tagSlug}
                headingText={configExploreMore.heading}
                headingTextZH={configExploreMore.headingZH}
                render={(children) => (
                  <div
                    className={cx(
                      styles.exploreMoreContainer,
                      customClass?.categoryLayout?.exploreMoreContainer,
                    )}
                  >
                    {!configExploreMore.hideDivider && <Divider />}
                    {children}
                    {!configExploreMore.hideDivider && <Divider />}
                  </div>
                )}
              />
            </SectionContext.Provider>
          </NoSSR>
        </div>
      )}
    </div>
  );
}
